import React from "react";
import { genURL, gengetURLTEST, } from '../_getjson';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import axios from 'axios'
require('../_css/PopUpARInvDebt.css');

export default class PopUpCsvarinvbalpay extends React.Component {
    state = {
        type: this.props.type,
        col: [],
        rows: [],
        Htext: "",
        SHtype: 3,
        casschkbox: "far fa-square",
        casschkboxs: false,
        ckbox_length: 0,
    }

    GetformatTimestamp = (date) => {
        if (date) {
            var myDate = new Date(date);
            var date1 = myDate.getDate(); if (myDate.getDate() < 10) { date = "0" + myDate.getDate(); }
            var month = (myDate.getMonth() + 1); if ((myDate.getMonth() + 1) < 10) { month = "0" + (myDate.getMonth() + 1); }
            var year = myDate.getFullYear() + 543;
            return date1 + "/" + month + "/" + year;
        } else {
            return "";
        }
    }
    Get_Data = (event) => {
        var dataArray = [];
        let Url = "";
        if (event === "ARInvDebt") {
            Url = "CSV_ARINVBALPLAY/CODE?arcode=" + this.props.ARCODE + "&top=" + 100;
        } else if (event.key === "Enter") {
            Url = "CSV_ARINVBALPLAY/CODE?arcode=" + this.props.ARCODE + "&top=" + 100;
        } else {
            return //--------------- Exit เมื่อไม่เข้าเงือนไขไหนเลย
        }
        console.log(genURL(Url));
        axios.get(genURL(Url), { timeout: 60000 }).then(res => {
            // GetCorServicei(Url, "iconsearch").then(res => {
            console.log("resCSV_ARINVBALPLAY", res);
            if (res.data.length >= 1) {
                for (let i = 0; i < res.data.length; i++) {
                    dataArray[i] = {
                        number: i + 1,
                        REFDOCNO: res.data[i].REFDOCNO,
                        REFTAXNO: res.data[i].REFTAXNO,
                        REFDOCDATE: this.GetformatTimestamp(res.data[i].REFDOCDATE),
                        CREDITCODE: res.data[i].CREDITCODE,
                        REFDUEDATE: this.GetformatTimestamp(res.data[i].REFDUEDATE),
                        TRANSNAME: res.data[i].TRANSNAME,
                        department: res.data[i].DEPARTNAME,
                        DEBTAMOUNT: res.data[i].DEBTAMOUNT,
                        DEBTBALANCE: res.data[i].DEBTBALANCE,
                        REFAMOUNT: res.data[i].REFAMOUNT,
                        REMARK: res.data[i].REMARK,
                        PAYBILLNO: res.data[i].PAYBILLNO,
                        SB: "0"
                    }
                }
                this.setState({ rows: dataArray });
            } else {
                dataArray = [];
                this.setState({ rows: dataArray });
            }
        });
    }
    componentDidMount() {
        var dataArray = [];
        var url
        this.setState({ sh_Deposit: true });
        url = "CSV_ARINVBALPLAY/GET?Arcode=" + this.props.ARCODE.trim() + "&Top" + 20
        console.log(genURL(url));
        axios.get(genURL(url), { timeout: 60000 }).then(res => {
            console.log("resCSV_ARINVBALPLAY", res);
            // Url = "http://Localhost:8080/Searchcsvarinvbalpay?ARCODE=" + this.props.ARCODE;
            // INSCorServicePostTest(Url).then(res => {
            if (res.data.length >= 1) {
                for (let ci = 0; ci < res.data.length; ci++) {
                    dataArray[ci] = {
                        number: ci + 1,
                        REFDOCNO: res.data[ci].REFDOCNO,
                        REFTAXNO: res.data[ci].REFTAXNO,
                        REFDOCDATE: this.GetformatTimestamp(res.data[ci].REFDOCDATE),
                        CREDITCODE: res.data[ci].CREDITCODE,
                        REFDUEDATE: this.GetformatTimestamp(res.data[ci].REFDUEDATE),
                        TRANSNAME: res.data[ci].TRANSNAME,
                        department: res.data[ci].DEPARTNAME,
                        DEBTAMOUNT: res.data[ci].DEBTAMOUNT,
                        DEBTBALANCE: res.data[ci].DEBTBALANCE,
                        REFAMOUNT: res.data[ci].REFAMOUNT,
                        REMARK: res.data[ci].REMARK,
                        PAYBILLNO: res.data[ci].PAYBILLNO,
                        SELFLAG: res.data[ci].SELFLAG,
                        REFDOCTYPE: res.data[ci].REFDOCTYPE,
                        SB: "0"
                    }
                }
                this.setState({ rows: dataArray });
            } else {
                this.setState({ rows: dataArray });
            }
        });
        this.setState({ col: dataArray, Htext: "เลือกเอกสาตั้งหนี้และใบวางบิล" });
    }
    cellcheckbok = (cell, row, enumObject, rowIndex) => {
        // console.log(rowIndex)
        var btn = this.state.rows[rowIndex].SB;
        var btnShow;
        switch (btn) {
            case "0": btnShow = <span>
                <i class="far fa-square " onClick={this.Update_Status.bind(null, rowIndex, "1")}> </i>
            </span>;
                break;
            case "1": btnShow = <span>
                <i class="far fa-check-square" onClick={this.Update_Status.bind(null, rowIndex, "0")}>  </i>
            </span>;
                break;
            default: btnShow = <span><i class="">  </i></span>;
        }
        return (<div>{btnShow}</div>)
    }
    Update_Status = (Row, Status) => {
        var dataArray
        if (Status === "ALL") {
            if (this.state.casschkboxs === false) {
                this.setState({ casschkbox: "far fa-check-square" });
                this.setState({ casschkboxs: !this.state.casschkboxs });
                dataArray = this.state.rows;
                for (var i = 0; i < this.state.rows.length && this.state.rows[i].REFDOCNO; i++) {
                    dataArray[i].SB = "1";
                }
                this.setState({ row: dataArray });
            } else {
                this.setState({ casschkbox: "far fa-square" });
                this.setState({ casschkboxs: !this.state.casschkboxs });
                dataArray = this.state.rows;

                for (var i1 = 0; i1 < this.state.rows.length && this.state.rows[i1].REFDOCNO; i1++) {
                    dataArray[i1].SB = "0";
                }
                this.setState({ row: dataArray });
            }
        } else {
            if (Status === "0") {
                this.setState({ casschkbox: "far fa-square" });
                this.setState({ casschkboxs: false });
            }
            dataArray = this.state.rows;
            dataArray[Row].SB = Status;
            this.setState({ rows: dataArray });
            var sb_length = 0;
            for (var i2 = 0; i2 < this.state.rows.length && this.state.rows[i2].REFDOCNO; i2++) {
                if (this.state.rows[i2].SB === 1) {
                    sb_length = sb_length + 1;
                }
            }
            if (sb_length === this.state.rows.length) {
                this.setState({ casschkbox: "far fa-check-square" });
                this.setState({ casschkboxs: true });
            }
        }
    }
    chkdata = (data) => {
        var redata = "";
        if (data !== "null") {
            redata = data;
        }
        if (typeof data === "undefined") {
            redata = ""
        }
        return redata;
    }
    onSelectRow = (row, col, id) => {
        if (col > 1) {
            var dataArray = this.state.rows;
            dataArray[id].SB = "1";
            this.setState({ rows: dataArray });
            var Data = this.state.rows;

            console.log(this.state.rows)
            for (var i = 0; i < this.state.rows.length; i++) {
                if (this.state.rows[i].SB === "1") {
                    var redata =
                        this.chkdata(Data[i].REFDOCNO) + "|" +
                        this.chkdata(Data[i].REFTAXNO) + "|" +
                        this.chkdata(Data[i].REFDOCDATE) + "|" +
                        this.chkdata(Data[i].CREDITCODE) + "|" +
                        this.chkdata(Data[i].REFDUEDATE) + "|" +
                        this.chkdata(Data[i].TRANSNAME) + "|" +
                        this.chkdata(Data[i].department) + "|" +
                        this.chkdata(Data[i].DEBTAMOUNT) + "|" +
                        this.chkdata(Data[i].DEBTBALANCE) + "|" +
                        this.chkdata(Data[i].REFAMOUNT) + "|" +
                        this.chkdata(Data[i].REMARK) + "|" +
                        this.chkdata(Data[i].PAYBILLNO) + "|" +
                        this.chkdata(Data[i].SELFLAG) + "|" +
                        this.chkdata(Data[i].REFDOCTYPE)
                    this.props.Get_PopUpcsvarinvbalpay(redata);
                }
            }
        }
    }
    onSubmit = () => {
        var Data = this.state.rows;
        for (var i = 0; i < this.state.rows.length; i++) {
            if (this.state.rows[i].SB === "1") {
                var redata =
                    this.chkdata(Data[i].REFDOCNO) + "|" +
                    this.chkdata(Data[i].REFTAXNO) + "|" +
                    this.chkdata(Data[i].REFDOCDATE) + "|" +
                    this.chkdata(Data[i].CREDITCODE) + "|" +
                    this.chkdata(Data[i].REFDUEDATE) + "|" +
                    this.chkdata(Data[i].TRANSNAME) + "|" +
                    this.chkdata(Data[i].department) + "|" +
                    this.chkdata(Data[i].DEBTAMOUNT) + "|" +
                    this.chkdata(Data[i].DEBTBALANCE) + "|" +
                    this.chkdata(Data[i].REFAMOUNT) + "|" +
                    this.chkdata(Data[i].REMARK) + "|" +
                    this.chkdata(Data[i].PAYBILLNO) + "|" +
                    this.chkdata(Data[i].SELFLAG) + "|" +
                    this.chkdata(Data[i].REFDOCTYPE)
                this.props.Get_PopUpcsvarinvbalpay(redata);
            }
        }
    }
    render() {
        return (
            <div className='popup' /* style={{ 'z-index': '100' }} */ >
                <div className='popup_inner' /* className='popup_inner_arinvdebt divBox' */>
                    {this.props.Data}
                    <div class="PopUpOtherDivH" align="left">
                        <div class="PopUpOtherDivH1"><i class="fas fa-search "/* fas fa-at */ > {this.state.Htext} </i></div>
                        <div class="PopUpOtherDivH2"><i class="fas fa-times" onClick={this.props.closePopup}></i></div>
                    </div>

                    <div class="panel-body divTable" align="right">

                        {/* {this.state.sh_Deposit === true ?
                            <div class=" form-group input-group col-xs-12 col-sm-6 col-md-6 col-lg-6" >
                                <input id="id1" type="text" class="form-control" ref="Search" onKeyPress={this.Get_Data.bind(null)} onBlur={this.Get_Data.bind(null, "ARInvDebt")} />
                                <span id="iconsearch" class="input-group-addon icon"><i class="fas fa-search"></i></span>
                            </div>
                            : null
                        } */}
                        <div >
                            <BootstrapTable
                                data={this.state.rows}
                                // pagination
                                options={{
                                    onRowClick: this.onSelectRow,
                                    noDataText: "ไม่พบข้อมูลที่ค้นหา",
                                }}
                                height="520"
                                hover condensed search={true}>
                                <TableHeaderColumn columnClassName="columnAll columnID" className="columnNumber" dataAlign="center" width="30" dataField='number' isKey> </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="30" dataField='SB' editable={false} dataAlign="center" dataFormat={this.cellcheckbok.bind(this)} > <div onClick={this.Update_Status.bind(null, "", "ALL")} > <i style={{ fontSize: '20px' }} class={this.state.casschkbox}> </i> </div> </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='REFDOCNO' > เอกสารตั้งหนี้ </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='REFTAXNO' > ใบกำกับภาษี </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='REFDOCDATE' > วันที่ตั้งหนี้ </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='CREDITCODE' dataAlign="left" > เครดิต </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='REFDUEDATE' dataAlign="left"> ครบกำหนด </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='TRANSNAME' dataAlign="left"> รายวัน </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='department' dataAlign="left"> แผนก </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='DEBTAMOUNT' dataAlign="right"> ยอดตั้งหนี้ </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='DEBTBALANCE' dataAlign="right"> ยอดคงค้าง </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='REFAMOUNT' dataAlign="right"> คงค้างสุทธิ </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='REMARK' dataAlign="left"> หมายเหตุ </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='PAYBILLNO' dataAlign="left"> ใบวางบิล </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='SELFLAG' dataAlign="left"> SELFLAG </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='REFDOCTYPE' dataAlign="left"> REFDOCTYPE </TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                        <button class="PUSDbtn" onClick={this.onSubmit}>
                            <i class="fas fa-check"> ตกลง </i>
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}